import DefaultAvatar from '@/app/pages/profile/components/DefaultAvatar'
import { cn, currencyFormatter } from '@/lib/utils'
import { AlertTriangle } from 'lucide-react'
import { StudentAwardInformation } from '../../award-form'
import { getStudentAwardBlockerNote } from '../../award-form-utils'

interface StudentCardProps {
  student: StudentAwardInformation
}

export function StudentCard({ student }: StudentCardProps) {
  const blockerNote = getStudentAwardBlockerNote({
    isAssociatedWithPurse: student.is_associated_with_purse,
    hasAwardAmount: student.has_award_amount,
  })

  return (
    <div
      className={cn(
        'group relative py-6 border-gray-100 last:border-b-0 transition-colors',
        blockerNote && 'px-4 border border-danger/30 bg-danger/5 rounded-xl'
      )}
    >
      {/* Header with Avatar and Name */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3 mb-3">
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center w-10 h-10 bg-primary/10 border border-primary/20 rounded-full">
              <DefaultAvatar
                variant={'neutral'}
                firstName={student.first_name}
                lastName={student.last_name}
              />
            </div>
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h3 className="font-semibold text-gray-900 text-sm">
                {student.first_name} {student.last_name} - {student.id}
              </h3>
            </div>
            <div className="flex items-center gap-1 text-base text-gray-800">
              <span className="font-normal text-sm text-gray-600">
                {student.applciant_email}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Award Amount — the exact figure ServiceNow supplied, never derived here */}
      <div className="mt-2">
        <div className="flex items-center justify-between pt-2 border-t border-gray-200">
          <div className="text-base font-medium text-gray-800 mb-1">
            Total Award
          </div>
          <div className="font-bold tracking-tight text-gray-800 text-base">
            {currencyFormatter.format(student.amount_to_be_awarded)}
          </div>
        </div>
      </div>

      {blockerNote && (
        <div className="mt-3 flex items-start gap-2">
          <AlertTriangle className="h-4 w-4 text-danger mt-0.5 flex-shrink-0" />
          <p className="text-sm font-medium text-danger">{blockerNote}</p>
        </div>
      )}
    </div>
  )
}
